import React, { createContext, useContext, useState, useEffect } from "react";

const PermissionContext = createContext();

export const usePermissions = () => useContext(PermissionContext);

export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const stored = localStorage.getItem("permissions");
    if (stored) {
      setPermissions(JSON.parse(stored));
    }
  }, []);

  const getModulePermission = (moduleId) => {
    if (!moduleId) return null;
    // Ensure moduleId is a number to match API data
    return permissions.find(p => p.module_id === Number(moduleId));
  };


  const hasAdditionalPermission = (moduleId, permissionKey) => {
    const module = getModulePermission(moduleId);
    if (!module || !module.additional_permissions) return false;

    const additional = module.additional_permissions.find(ap => ap.module_id === Number(moduleId));
    return additional && additional[permissionKey] === "1";
  };

  return (
    // <PermissionContext.Provider value={{ permissions, getModulePermission }}>
    //   {children}
    // </PermissionContext.Provider>

    <PermissionContext.Provider value={{ permissions, getModulePermission, setPermissions, hasAdditionalPermission }}>
      {children}
    </PermissionContext.Provider>
  );
};
